/**
 * Clock port — injectable time and timers.
 *
 * The widget's UX-critical logic is timing logic (typing-indicator minimum
 * duration, chat-widget grace buffering). Routing all time access through
 * this port makes that logic deterministic under test.
 */
export function createSystemClock() {
    return {
        now() {
            return Date.now();
        },
        setTimeout(fn, ms) {
            return setTimeout(fn, ms);
        },
        clearTimeout(handle) {
            clearTimeout(handle);
        },
    };
}
